import React, { Component } from 'react';
import Util from '../../Util';
import Box from '../../componentes/Box';
import Tabs from '../../componentes/Tabs';
import Tab from '../../componentes/Tab';
import BotaoImprimir from '../../componentes/BotaoImprimir';
import AndamentoProtocolo from './AndamentoProtocolo';

class DetalhesProtocolo extends Component {
  getParametrosRelatorio(protocolo) {
    return ({
      chaveAcesso: protocolo.chaveAcesso
    });
  }

  renderRequerentes(protocolo) {
    let itens = protocolo.requerentes.map((requerente, index) => {
      return (
        <li key={index}>{requerente.pessoa.razaoSocial}</li>
      );
    });
    return (
      <div>
        <ul className="list-unstyled">{itens}</ul>
      </div>
    );
  }

  renderTitulo(protocolo) {
    if (protocolo.requerentes && protocolo.requerentes.length > 0) {
      let titulo = protocolo.requerentes[0].pessoa.razaoSocial;
      if (protocolo.requerentes.length > 1) {
        titulo += ' e outros...';
      }
      return `${titulo} - ${protocolo.numero}/${protocolo.ano}`;
    }
    return `${protocolo.numero}/${protocolo.ano}`;
  }

  render() {
    const minimizado = this.props.protocolos.length > 1;
    return (
      <div className="box-group" id="accordionProtocolos">
        {
          this.props.protocolos.map((protocolo, key) => {
            return (
              <Box key={key} titulo={this.renderTitulo(protocolo)} tipo="solid" minimizado={minimizado} accordion>
                <Tabs parentKey={key}>
                  <Tab label="Informações" active>
                    <dl className="dl-horizontal">
                      <dt>Número do Protocolo</dt>
                      <dd>{protocolo.numero}</dd>
                      <dt>Data de abertura</dt>
                      <dd>{Util.formataData(protocolo.dataAbertura)}</dd>
                      <dt>Situação</dt>
                      <dd>{protocolo.situacaoProtocolo.nome}</dd>
                      <dt>Espécie</dt>
                      <dd>{protocolo.especieProtocolo.nome}</dd>
                      <dt>Objeto do Protocolo</dt>
                      <dd>{protocolo.objetoProtocolo.descricao}</dd>
                      <dt>Unidade de Abertura</dt>
                      <dd>{protocolo.unidadeAbertura.nome}</dd>
                      {protocolo.unidadeEstacionada && <dt>Unidade Atual</dt>}
                      {protocolo.unidadeEstacionada && <dd>{protocolo.unidadeEstacionada.nome}</dd>}
                      <dt>Valor do processo</dt>
                      <dd>{Util.formataMoeda(protocolo.valorProcesso)}</dd>
                      <dt>Requerentes</dt>
                      <dd>{this.renderRequerentes(protocolo)}</dd>
                    </dl>
                  </Tab>
                  <Tab label="Andamentos">
                    <AndamentoProtocolo andamentos={protocolo.andamentos} />
                  </Tab>
                </Tabs>
                <BotaoImprimir nomeRelatorio="NotaProtocolo" data={this.getParametrosRelatorio(protocolo)} />
              </Box>
            );
          })
        }
      </div>
    );
  }
}

export default DetalhesProtocolo;


// WEBPACK FOOTER //
// ./src/modulos/protocolo/consultar/DetalhesProtocolo.js